import { Component, Input } from "@angular/core";

// QSL-11396: promoted from finance-analytics/components/kpi-card so new panels
// (starting with Platform Stats) don't duplicate it. Finance Analytics keeps its
// own local copy for now — consolidating that one is a separate, unrelated change.
@Component({
  selector: "app-kpi-card",
  templateUrl: "./kpi-card.component.html",
  styleUrls: ["./kpi-card.component.scss"],
})
export class KpiCardComponent {
  @Input() title: string = "";
  @Input() value: string | number = "";
  @Input() subtitle: string = "";
  @Input() icon: string = "analytics";
  @Input() trend: number = 0;
  @Input() color: string = "#3f51b5";

  get trendClass(): string {
    if (this.trend > 0) return "trend-up";
    if (this.trend < 0) return "trend-down";
    return "trend-neutral";
  }

  get trendIcon(): string {
    if (this.trend > 0) return "trending_up";
    if (this.trend < 0) return "trending_down";
    return "trending_flat";
  }

  get formattedTrend(): string {
    if (this.trend === 0) return "0%";
    const sign = this.trend > 0 ? "+" : "";
    return `${sign}${this.trend.toFixed(1)}%`;
  }
}
